import { Box, Grid } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../App";
import { Alert, Dialog } from "../../../../layout";
import { CartContext } from "../POS";
import SelectVariantProd from "./SelectVariantProd";
import { action, API, controller } from "../../../../api/api";
import ProdWidget from "./ProdWidget";
import { lsGet, playAudio, RandomCode } from "hooks";
import { AddToCartSound, ErrorSound } from "assets";

const Products = () => {
  const register = lsGet("activeReg")?.register;
  const { setLoader } = useContext(AppContext);
  const [prods, setProds] = useState([]);
  const { selOutlet } = useContext(AppContext);
  const { cartData, setCartData } = useContext(CartContext);
  const [selVarProd, setSelVarProd] = useState();
  const [showVarProdForm, setShowVarProdForm] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    // Get Products
    setLoader(true);
    API(controller.Product + action.GetProdsForPosBody).getById(30, (res) => {
      res && res.status === 200 && setProds([...res.result]);
      setLoader(false);
    });

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selOutlet]);

  const handleAddToCart = (val) => {
    switch (val.prodType) {
      // Standard Product
      case 1:
      case 3:
        if (
          cartData.sellItems &&
          cartData.sellItems.some(
            (j) => j.prodId === val.id && j.prodType === val.prodType
          )
        ) {
          setCartData((j) => ({
            ...j,
            sellItems: j.sellItems.map((x) => {
              return {
                ...(x.prodId === val.id && x.prodType === val.prodType
                  ? {
                      ...x,
                      qty: parseFloat(x.qty) + 1,
                      totalPrice: x.totalPrice + x.price,
                    }
                  : x),
              };
            }),
          }));
        } else {
          setCartData((j) => ({
            ...j,
            sellItems: [
              {
                key: RandomCode(15),
                prodType: val.prodType,
                prodId: val.id,
                prod: val,
                qty: 1,
                price: val.rtlPrice,
                totalPrice: val.rtlPrice,
                disType: 2,
                discount: "",
                note: "",
              },
              ...j.sellItems,
            ],
          }));
        }
        register?.enableSound && playAudio(AddToCartSound);

        break;
      // Variant Product
      case 2:
        handleShowVariants(val);
        break;
      default:
        register?.enableSound && playAudio(ErrorSound);
        break;
    }
  };

  const handleSelVarProd = (selProd, handleClose) => {
    var _selectedProd = cartData.sellItems.find(
      (j) => j.varProdId === selProd.varProdId
    );
    if (_selectedProd) {
      setCartData((j) => ({
        ...j,
        sellItems: [
          ...j.sellItems.map((x) => {
            if (x.prodType === 2) {
              return {
                ...(x.prodId === selProd.prodId &&
                x.varProdId === selProd.varProdId
                  ? {
                      ...x,
                      qty: parseFloat(x.qty) + 1,
                      totalPrice: x.totalPrice + x.price,
                    }
                  : x),
              };
            }
            return { ...x };
          }),
        ],
      }));
    } else if (selProd.prod && selProd.varProd)
      setCartData((j) => {
        return {
          ...j,
          sellItems: [
            {
              key: RandomCode(15),
              prodType: selProd.prodType,
              prodId: selProd.prodId,
              prod: selProd.prod,
              varProdId: selProd.varProdId,
              varProd: selProd.varProd,
              qty: 1,
              price: selProd.prod.rtlPrice,
              totalPrice: selProd.prod.rtlPrice,
              discount: "",
              disAmt: 0,
              disType: 2,
              note: "",
            },
            ...j.sellItems,
          ],
        };
      });
    register?.enableSound && playAudio(AddToCartSound);
    handleClose();
  };

  const handleShowVariants = (val) => {
    setSelVarProd(val);
    setShowVarProdForm(true);
  };

  return (
    <>
      <Box
        sx={{
          height: {},
          overflow: "auto",
          borderRadius: "0.8rem",
          padding: "10px 10px 10px 8px",
        }}
      >
        <Grid container spacing={2}>
          {prods.map((prod, i) => (
            <Grid
              item
              xs={6}
              sm={4}
              md={3}
              xl={2}
              key={i}
              onClick={() => handleAddToCart(prod)}
            >
              <ProdWidget value={prod} />
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Variant Product Form */}
      {selVarProd && showVarProdForm && (
        <Dialog show={showVarProdForm} onClose={false} maxWidth="sm">
          <SelectVariantProd
            {...{
              setShowForm: setShowVarProdForm,
              prod: selVarProd,
              handleSelVarProd,
              setAlert,
            }}
          />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Products;
